import React, { useState } from "react";
import { useSpring, animated } from "react-spring";
import { Button, useMediaQuery } from "@mui/material";
import CustomLanding from "../../../pages/YogaSpace/Components/CustomLanding";
import { useTranslation } from "react-i18next";

const PreLoader = React.memo(() => {
  const { t } = useTranslation(); // Usa useTranslation per ottenere informazioni sulla lingua corrente
  const [isVisible, setIsVisible] = useState(true);
  const isTablet = useMediaQuery("(min-width: 668px)");
  const slideUp = useSpring({
    transform: isVisible ? "translateY(0%)" : "translateY(-100%)",
    config: { tension: 220, friction: 120 },
  });

  const handleEnterClick = () => {
    setIsVisible(false);
    localStorage.setItem("preloaderVisible", JSON.stringify(false));
  };

  return (
    <animated.div
      style={{
        ...slideUp,
        position: "fixed",
        top: 0,
        zIndex: 50,
        overflow: "hidden",
        backgroundColor: "#ece9e0",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        backgroundPosition: "center",
      }}
    >
      <CustomLanding />
      <Button
        onClick={handleEnterClick}
        style={{
          position: "absolute",
          bottom: isTablet ? "10%" : "20%",
          padding: "5px 30px",
          fontSize: "18px",
          cursor: "pointer",
          backgroundColor: "#33414C",
          color: "#fff",
          zIndex: 1000,
          border: "none",
          borderRadius: "5px",
        }}
      >
        {t("entra")}
      </Button>
    </animated.div>
  );
});

export default PreLoader;
